module.exports = __webpack_public_path__ + "static/media/invoice-file.db88ab8b.svg";